<script>

  /*
  |--------------------------------------------------------------------------
  | Dependency Definitions
  |--------------------------------------------------------------------------
  */

  import Vue from 'vue';

  import axios from 'axios';

    import Swal from 'sweetalert2';



  /*
  |--------------------------------------------------------------------------
  | Component Implementation
  |--------------------------------------------------------------------------
  */

  export default {
    name: 'like-button',

    props: [
      'productID',
      'liked',
      'mode',
      'language'
    ],

    mounted() {
      this.currentLiked = this.liked;
    },

    data() {
      return {
        currentLiked: false
      }
    },

    computed: {
      addedText() {
        if (this.language == 'sv') {
          if (this.currentLiked) {
            return 'Produkt tillagd!';
          }

          return 'Produkt borttagen!';
        }

        if (this.language == 'en') {
          if (this.currentLiked) {
            return 'Product added!';
          }

          return 'Product removed!';
        }

        if (this.currentLiked) {
          return 'Produkt tillagd!';
        }

        return 'Produkt borttagen!';
      }
    },

    methods: {
      likeProduct() {
        var self = this;

        this.loading = true;

        axios.put('/api/v1/products/' + this.productID + '/like', {
          liked: this.currentLiked
        })
        .then(function (response) {
          self.currentLiked = response.data;
          self.loading = false;

          self.$emit("productLiked", self.currentLiked);

          if (this.mode != 'account') {
            Swal.fire({
              icon: 'success',
              showConfirmButton: false,
              timer: 1000,
              text: self.addedText
            });
          }
        })
        .catch(function (error) {
          self.loading = false;

          console.log("Error liking product: ", error);
        });
      },
    }
  };
</script>

<template>
  <div>
    <svg v-if="!currentLiked" @click="likeProduct" width="25px" height="24px" viewBox="0 0 25 24">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(0.499525, 0.987322)" fill="#000000" fill-rule="nonzero">
          <path d="M22.770822,7.694013 L16.2168149,6.73850068 L13.2874743,0.79907197 C12.7626155,-0.259617739 11.2418705,-0.273075659 10.7125257,0.79907197 L7.78318506,6.73850068 L1.229178,7.694013 C0.0538529828,7.86447999 -0.417174218,9.31344938 0.435160717,10.1433544 L5.17683454,14.763907 L4.05534121,21.2909982 C3.85347241,22.4708092 5.09608702,23.3545459 6.13683284,22.8027712 L12,19.7209075 L17.8631672,22.8027712 C18.903913,23.35006 20.1465276,22.4708092 19.9446588,21.2909982 L18.8231655,14.763907 L23.5648393,10.1433544 C24.4171742,9.31344938 23.946147,7.86447999 22.770822,7.694013 L22.770822,7.694013 Z M16.5128892,14.0102635 L17.5760649,20.2188506 L12,17.28951 L6.42393513,20.2188506 L7.48711082,14.0102635 L2.97422163,9.61400959 L9.20972458,8.70784298 L12,3.05551656 L14.7902754,8.70784298 L21.0257784,9.61400959 L16.5128892,14.0102635 Z"></path>
        </g>
      </g>
    </svg>

    <svg v-if="currentLiked" @click="likeProduct" width="25px" height="24px" viewBox="0 0 25 24">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(0.499525, 0.987322)" fill="#F8D359" fill-rule="nonzero">
          <path d="M10.7125257,0.79907197 L7.78318506,6.73850068 L1.229178,7.694013 C0.0538529828,7.86447999 -0.417174218,9.31344938 0.435160717,10.1433544 L5.17683454,14.763907 L4.05534121,21.2909982 C3.85347241,22.4708092 5.09608702,23.3545459 6.13683284,22.8027712 L12,19.7209075 L17.8631672,22.8027712 C18.903913,23.35006 20.1465276,22.4708092 19.9446588,21.2909982 L18.8231655,14.763907 L23.5648393,10.1433544 C24.4171742,9.31344938 23.946147,7.86447999 22.770822,7.694013 L16.2168149,6.73850068 L13.2874743,0.79907197 C12.7626155,-0.259617739 11.2418705,-0.273075659 10.7125257,0.79907197 Z" id="Path"></path>
        </g>
      </g>
    </svg>
  </div>
</template>

<style lang="scss" scoped>

</style>
